
import React, { Fragment, useState } from 'react'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import UsersService from '@/Services/UsersService'

import InputSearch from '@/Components/InputSearch/InputSearch'
import UserItem from './UserItem'

const SearchUsersTab = () => {

  const { t } = useTranslation()

  const { teamSelected } = useTeams()

  const [searched, setSearched] = useState(false)
  const [searching, setSearching] = useState(false)

  const [users, setUsers] = useState<any[]>([])

  const searchUsers = async (criteria: string) => {

    if (!criteria) {

      return
    }

    setSearching(true)

    const [err, data] = await UsersService.search({ criteria, team_id: teamSelected._id })

    if (err) return console.log(err)

    setUsers(data)

    setSearching(false)
    setSearched(true)
  }

  return (
    <Fragment>
      <div className='mb-2'>
        <InputSearch
            placeholder='Buscar usuarios'
            onChange={(criteria: string) => {

              if (!criteria.length) {

                setUsers([])
                setSearched(false)
                return
              }

              searchUsers(criteria)
            }}
          />
      </div>
      <div className='scroller' style={{ height: 'auto' }}>
        {searching && t('TEAMMEMBER_SELECTOR:Searching')}
        {searched && (
          <>
            {!users.length ? (
              <div className="alert alert-secondary">
                {t('TEAMMEMBER_SELECTOR:NoUsersFound')}
              </div>
            ) : (
              <div>
                {users.map((user: any, i: number) => (
                  <UserItem key={user._id} user={user} />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </Fragment>
  )
}

export default SearchUsersTab
